export const ACTIONS = ["list", "show", "approve", "reject"] as const;

export const REJECT_MODES = ["rework", "terminate"] as const;
